/* NTL Home Carrusel — comportamiento de la sección ntl-home-carrusel.
   Ganadora de AO-021 («Home herobanner carrusel», Variante 1 v1.5.0), llevada al tema el 02/11/2026.
   - Avanza sola cada data-interval ms y se para del todo cuando la clienta toca, desliza, usa la rueda en
     horizontal o pulsa una flecha o un punto. Se pausa con el ratón encima, el foco dentro, la pestaña oculta
     o el carrusel fuera de pantalla.
   - Infinito: siempre hay una diapositiva a cada lado de la que se ve. Al pararse, la de un extremo pasa al
     otro con la propiedad CSS «order» y el scroll se corrige en el mismo instante; mientras desliza no se
     ejecuta nada nuestro ni se mide nada.
   - Las imágenes de las diapositivas 2 y siguientes (data-src / data-srcset) se cargan cuando el navegador
     queda libre tras cargar la página.
   - En desktop, el alto máximo depende de dónde empieza el carrusel: se guarda en --hc-top. */
(function () {
  'use strict';
  var W = window, D = document;

  function init(root) {
    if (!root || root.__ntlHc) return;
    var S = root.querySelector('.ntl-hc__track');
    var ui = root.querySelector('.ntl-hc__ui');
    if (!S || !ui) return;
    var slides = Array.prototype.filter.call(S.children, function (el) { return el.classList.contains('ntl-hc__slide'); });
    var TOTAL = slides.length;
    if (TOTAL < 2) return;

    var INTERVAL = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var reduced = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var dotEls = ui.querySelectorAll('.ntl-hc__dot');
    var api = root.__ntlHc = {};

    /* Imágenes de las demás diapositivas: después del primer pintado y cuando el navegador está libre */
    var imgsLoaded = false;
    function loadImages() {
      if (imgsLoaded) return;
      imgsLoaded = true;
      Array.prototype.forEach.call(S.querySelectorAll('[data-srcset]'), function (e) { e.setAttribute('srcset', e.getAttribute('data-srcset')); });
      Array.prototype.forEach.call(S.querySelectorAll('[data-src]'), function (e) { e.setAttribute('src', e.getAttribute('data-src')); });
    }
    (function whenIdle() {
      var run = function () {
        if (W.requestIdleCallback) W.requestIdleCallback(loadImages, { timeout: 2500 });
        else setTimeout(loadImages, 300);
      };
      if (D.readyState === 'complete') run();
      else W.addEventListener('load', run);
    })();

    /* ── Estado ── */
    var idx = 0, timer = 0;
    var stopped = false;                  /* la clienta ha tocado, deslizado o pulsado: se acabó el avance solo */
    var hover = 0, focused = false, hidden = !!D.hidden, visible = true;
    var lastUser = 0;                     /* última acción de la clienta (para saber si un cambio fue con el dedo) */
    var btnUntil = 0;                     /* hasta cuándo un cambio de diapositiva se debe a una flecha o un punto */
    var lastResize = 0;                   /* justo después de un cambio de tamaño, el scroll lo mueve el navegador */

    function canRun() { return !stopped && !reduced && !hover && !focused && !hidden && visible; }
    function schedule() {
      clearTimeout(timer);
      if (canRun()) timer = setTimeout(tick, INTERVAL);
    }
    function stopAuto() {
      if (stopped) return;
      stopped = true;
      clearTimeout(timer);
      S.setAttribute('aria-live', 'polite');
      loadImages();
    }
    api.stop = stopAuto;

    /* La diapositiva que pasa por el centro: punto encendido y avance solo */
    function setActive(i) {
      idx = i;
      for (var k = 0; k < dotEls.length; k++) {
        if (k === i) dotEls[k].setAttribute('aria-current', 'true'); else dotEls[k].removeAttribute('aria-current');
      }
      schedule();
    }
    /* Las que no se ven quedan fuera del lector de pantalla y del tabulador. Se cambia al pararse, no a mitad
       del movimiento: así el navegador no recalcula nada mientras desliza. */
    function hideSlide(el, off) {
      if (off) { el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', ''); }
      else { el.removeAttribute('aria-hidden'); el.removeAttribute('inert'); }
    }

    /* ── Carrusel infinito ── El orden en pantalla (ord) y el ancho de una diapositiva (cw) se guardan aquí. */
    var ord = slides.slice();
    var cw = S.getBoundingClientRect().width || S.clientWidth || 1;
    function applyOrder() { for (var k = 0; k < TOTAL; k++) ord[k].style.order = k; }

    /* Al pararse: se recoloca la pista y, si ha llegado otra diapositiva, sus textos entran (.is-enter) y la
       anterior, que ya no se ve, esconde los suyos. Primero se lee y luego se escribe, una sola vez. */
    var dragging = false, settleT = 0, shown = slides[0];
    function settle() {
      if (dragging) return;
      var sl = S.scrollLeft, p = Math.max(0, Math.min(TOTAL - 1, Math.round(sl / cw)));
      if (Math.abs(sl - p * cw) > 2) return; /* aún está entre dos diapositivas */
      var el = ord[p];
      if (p !== 1) {
        while (p > 1) { ord.push(ord.shift()); p--; }
        while (p < 1) { ord.unshift(ord.pop()); p++; }
        applyOrder();
        S.scrollLeft = cw;
      }
      if (el !== shown) {
        hideSlide(shown, true); shown.classList.remove('is-in', 'is-enter');
        hideSlide(el, false); el.classList.add('is-in', 'is-enter');
        shown = el;
      }
    }
    function settleLater() { clearTimeout(settleT); settleT = setTimeout(settle, 150); }
    /* «scrollend» avisa cuando se para; donde no existe (Safari), se espera a que deje de moverse 150 ms */
    if ('onscrollend' in W) S.addEventListener('scrollend', settle);
    else S.addEventListener('scroll', settleLater, { passive: true });

    function goTo(i) {
      if (i === idx) { schedule(); return; }
      var left = ord.indexOf(slides[i]) * cw;
      try { S.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' }); } catch (e) { S.scrollLeft = left; }
    }
    function step(d) {
      var p = ord.indexOf(slides[idx]);
      if (p + d > TOTAL - 1) { ord.push(ord.shift()); p--; applyOrder(); S.scrollLeft = p * cw; }
      else if (p + d < 0) { ord.unshift(ord.pop()); p++; applyOrder(); S.scrollLeft = p * cw; }
      goTo(slides.indexOf(ord[p + d]));
    }
    function tick() {
      if (!canRun()) return;
      loadImages();
      step(1);
      schedule();
    }
    api.goTo = function (i) { loadImages(); goTo(i); };

    /* Qué diapositiva se ve: lo avisa el propio navegador cuando una pasa de la mitad (vale para dedo, rueda,
       teclado y botones). Justo después de un cambio de tamaño se ignora: el scroll lo mueve el navegador. */
    var slideIO = new IntersectionObserver(function (ents) {
      if (Date.now() - lastResize < 350) return;
      for (var e = 0; e < ents.length; e++) {
        if (!ents[e].isIntersecting || ents[e].intersectionRatio < 0.5) continue;
        var i = slides.indexOf(ents[e].target);
        if (i === idx) continue;
        var byUser = Date.now() - lastUser < 1500 && Date.now() > btnUntil;
        setActive(i);
        if (byUser) stopAuto();
      }
    }, { root: S, threshold: 0.5 });
    slides.forEach(function (s) { slideIO.observe(s); });

    /* La clienta toca, desliza o usa la rueda en el banner: el avance solo se acaba del todo */
    var touch = function () { lastUser = Date.now(); stopAuto(); };
    var down = function () { touch(); dragging = true; };
    var up = function () { if (!dragging) return; dragging = false; settleLater(); };
    S.addEventListener('pointerdown', down, { passive: true });
    S.addEventListener('touchstart', down, { passive: true });
    W.addEventListener('pointerup', up, { passive: true });
    W.addEventListener('touchend', up, { passive: true });
    W.addEventListener('touchcancel', up, { passive: true });
    S.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) touch();
    }, { passive: true });
    S.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') touch();
    });

    /* Flechas y puntos */
    ui.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b) return;
      lastUser = Date.now();
      stopAuto();
      btnUntil = Date.now() + 1500;
      if (b.classList.contains('ntl-hc__arrow--prev')) step(-1);
      else if (b.classList.contains('ntl-hc__arrow--next')) step(1);
      else if (b.hasAttribute('data-i')) goTo(parseInt(b.getAttribute('data-i'), 10));
    });
    ui.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('button')) touch(); }, { passive: true });

    /* Pausas temporales: ratón encima, foco dentro, pestaña oculta, carrusel fuera de pantalla */
    var hov = function (d) { return function () { hover = Math.max(0, hover + d); if (d > 0) clearTimeout(timer); else schedule(); }; };
    root.addEventListener('mouseenter', hov(1));
    root.addEventListener('mouseleave', hov(-1));
    root.addEventListener('focusin', function () { focused = true; clearTimeout(timer); });
    root.addEventListener('focusout', function () { focused = false; schedule(); });
    D.addEventListener('visibilitychange', function () {
      hidden = !!D.hidden;
      if (hidden) clearTimeout(timer); else schedule();
    });
    new IntersectionObserver(function (ents) {
      visible = ents[0].intersectionRatio >= 0.5;
      if (visible) schedule(); else clearTimeout(timer);
    }, { threshold: [0, 0.5] }).observe(S);

    /* Dónde empieza el carrusel (debajo de la cabecera): la CSS lo usa para limitar su altura en desktop */
    var lastTop = -1;
    function setTop() {
      var t = Math.round(S.getBoundingClientRect().top + (W.pageYOffset || 0));
      if (t !== lastTop) { lastTop = t; root.style.setProperty('--hc-top', t + 'px'); }
    }

    /* Cambios de ancho: recolocar la diapositiva y la altura de la cabecera */
    var rzT = 0;
    function realign() {
      setTop(); /* otra vez cuando la cabecera ya se ha recolocado (al pasar de móvil a desktop cambia de alto) */
      var left = ord.indexOf(slides[idx]) * cw;
      if (Math.abs(S.scrollLeft - left) > 1) S.scrollLeft = left;
    }
    function onWidth(w) {
      if (!w || Math.abs(w - cw) <= 0.5) return;
      cw = w;
      setTop();
      lastResize = Date.now();
      clearTimeout(rzT);
      rzT = setTimeout(realign, 120);
    }
    if ('ResizeObserver' in W) {
      new ResizeObserver(function (en) { onWidth(en[0].contentRect.width); }).observe(S);
      /* En desktop, mientras carga la página, la cabecera puede cambiar de alto: se vigila hasta 3 s después
         de cargar y luego se deja (al bajar por la página no cambia). En el móvil no hace falta. */
      if (W.matchMedia && W.matchMedia('(min-width: 750px)').matches) {
        var bodyRO = new ResizeObserver(setTop);
        bodyRO.observe(D.body);
        var stopBody = function () { setTimeout(function () { setTop(); bodyRO.disconnect(); }, 3000); };
        if (D.readyState === 'complete') stopBody(); else W.addEventListener('load', stopBody);
      }
    } else {
      W.addEventListener('resize', function () { onWidth(S.clientWidth); });
    }
    setTop();

    setActive(0);
    settle(); /* la última pasa a la izquierda de la primera (fuera de la vista): se puede retroceder desde el principio */
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || D).querySelectorAll('[data-ntl-hc]'), init);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Editor de temas: al recargar la sección se monta de nuevo; al elegir una diapositiva, se va a ella y se para */
  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  D.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-ntl-hc]');
    if (r && r.__ntlHc && r.__ntlHc.stop) r.__ntlHc.stop();
  });
  D.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.ntl-hc__slide');
    var r = slide && slide.closest('[data-ntl-hc]');
    if (!r || !r.__ntlHc || !r.__ntlHc.goTo) return;
    r.__ntlHc.stop();
    var all = Array.prototype.filter.call(slide.parentNode.children, function (el) { return el.classList.contains('ntl-hc__slide'); });
    r.__ntlHc.goTo(all.indexOf(slide));
  });
})();
